import { render, staticRenderFns } from "./MenuActivity.vue?vue&type=template&id=9d9c0a8a&"
import script from "./MenuActivity.vue?vue&type=script&lang=js&"
export * from "./MenuActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports